(function ($) {
    $.fn.extend({
    	
		/**
		 * KONTO-CHECKBOX
		 */  
		kontoCheckboxCreate: function () {
            var cb = $(this);
            cb.addClass("checkbox");
            var disabled = cb.hasClass("disabled");
            var readonly = cb.hasClass("readonly");
			var checked = cb.data("checked");
            var label = cb.data("label");
            var id = cb.data("id");
            var clazz = cb.data("class");
            var name = cb.data("name");
            
            var labelEl = $("<label>");
            //labelEl.html(label);
            
            var inputEl = $("<input>");
            inputEl.attr("type", "checkbox");
            if (id)
                inputEl.attr("id", id);
            if (name)
                inputEl.attr("name", name);
            if (disabled)
                inputEl.prop("disabled", true);
            if (readonly)
                inputEl.prop("readonly", true);
			if (checked){
                inputEl.prop("checked", true);				
			}
			else{
				inputEl.prop("checked", false);	
			}
            if (clazz)
                inputEl.addClass(clazz);
            
            labelEl.append(inputEl);
            cb.append(labelEl);
            labelEl.append(label); 			
		},
		
		/**
		 * KONTO-CHECKBOX-EXTENDED 
		 */    	
    	kontoCheckboxExtendedCreate: function () {
			var cb = $(this);
			var chale = cb.parent();
			var row = cb.closest('.row');			
			
			//ID
			var _id = '';
			var _id_checkbox = '';
			var _id_hidden = '';
			var _for = '';
			if (typeof cb.data('id') != 'undefined') {
				cb.prop('id', cb.data('id'));
				_id_checkbox = ' id="' + cb.data('id') + '_checkbox"';
				_id_hidden = ' id="' + cb.data('id') + '_hidden"'; 
				_for = ' for="' + cb.data('id') + '_checkbox"';
			}					
			
			//DODATNE KLASE
			row.addClass('rowEqHeight');	
			
			var _checked = false;				
			if (typeof cb.data('checked') != 'undefined') {
				_checked = cb.data('checked');					
			}	
					
			var _element_type = 'div';
					
			var _inline_with_label = false;				
			if (typeof cb.data('inline-with-label') != 'undefined') {
				_inline_with_label = cb.data('inline-with-label');			
			}								
								
			var _border = false;
			if (typeof cb.data('border') != 'undefined') {
				_border = cb.data('border');					
			}								
													
			var _radio_look = false;
			if (typeof cb.data('radio-look') != 'undefined') {
				_radio_look = cb.data('radio-look');					
			}													
			
			var _readonly_color = false;
			if (typeof cb.data('readonly-color') != 'undefined') {
				_readonly_color = cb.data('readonly-color');					
			}						
			
			//LABEL - MOŽE BITI KONTROLNA SA LABEL TAG-om ILI PLAIN TEKST
			//PO DEFAULTU OBIČNA - PLAIN
			var _label_control = false;
			if (typeof cb.data('label-control') != 'undefined') {
				_label_control = cb.data('label-control');
			}						
			
			var _label_normal_weight = true;
			if (typeof cb.data('label-normal-weight') != 'undefined') {
				_label_normal_weight = cb.data('label-normal-weight');
			}					
			
			var _align_bottom = false;
			if (typeof cb.data('align-bottom') != 'undefined') {
				_align_bottom = cb.data('align-bottom');					
			}					
			
			var _align_right = false;
			if (typeof cb.data('align-right') != 'undefined') {
				_align_right = cb.data('align-right');					
			}	
			 											
			//LABELA PO DEFAULTU IZA CHECKBOXA	
			var _label_reverse = false;
			if (typeof cb.data('label-reverse') != 'undefined') {
				_label_reverse = cb.data('label-reverse');
			}		
			var _label_margin = '';	
			if(_label_reverse) {
				_label_margin = 'checkBoxRightPadding';
			}
			else {
				_label_margin = 'checkBoxLeftPadding';
			}		
					
			if(_inline_with_label){
				_element_type = 'span';	
				cb.addClass('displayInline');							
			}		
			
			if(_align_right){
				cb.addClass('pull right');
			}
			
			var _additional_classes = '';
			if (typeof cb.data('additional-classes') != 'undefined') {	
				_additional_classes = cb.data('additional-classes');
			}
					
			var _additional_checkbox_classes = '';
			if (typeof cb.data('additional-checkbox-classes') != 'undefined') {	
				_additional_checkbox_classes = cb.data('additional-checkbox-classes');
			}	
			
			var _in_single_row = false;
			if (typeof cb.data('in-single-row') != 'undefined') {
				_in_single_row = cb.data('in-single-row');					
			}	
					
			var _hint = '';
			if (typeof cb.data('hint') != 'undefined') {	
				_hint = cb.data('hint');
			}					
					
			//LABEL - TEKST LABELE MORA BITI U DATA-LABEL FIELDU - UNUTAR DIV-a SE VIDI KOD UČITAVANJA FORME
			var _label = '';
			if (typeof cb.data('label') != 'undefined') {			
				_label = '<label class="konto-checkbox-label ' + _label_margin + ' cursorPointer verticalAlignMiddle kce_normalwrap ';
				if(_label_normal_weight){
					_label += 'fontWeightNormal';
				}
				_label += ' checkBoxTopPaddingLabel checkBoxTopMarginLabelFix" ' + _for + '>' + cb.data('label') + '</label>';																
			}								
								
			//NAME - ZA POLJE KOJE IDE ORM-u
			var _name = '';
			if (typeof cb.data('orm-name') != 'undefined') {
				_name = ' name="' + cb.data('orm-name') + '"';						
			}
			
			//FUNKCIONALNOST PREMA ORM-U
			//UKOLIKO STAVIMO REVERSE NA TRUE VRIJEDNOST KOJA IDE ORM-UJE OBRATNA OD CHECKBOXA
			//ČESTO POTREBNO KOD OPCIJA. NPR CHECKBOX NAM SE ZOVE "AKTIVAN" A U TABLICI SE PAMTI UKOLIKO JE NEAKTIVAN
			//PO DEFAULTU FALSE
			//ZA REVERSE FUNKCIONALNOST TREBA NAM HIDDEN POLJE ZA PRIJENOS VRIJEDNOSTI
			var _value_reverse = false;
			if (typeof cb.data('orm-reverse') != 'undefined') {
				_value_reverse = cb.data('orm-reverse');					
			}						
			
			var _checkbox = '';
        	if (_value_reverse) {	
				_checkbox = '<input type="checkbox" class="cursorPointer kce_valigntop';
				 if (_additional_checkbox_classes != ''){
					_checkbox += ' ' + _additional_checkbox_classes; 
				 }
				 _checkbox += '"';				
				 if(_checked){
					_checkbox += ' checked '; 
				}
				_checkbox += _id_checkbox + ' >';
				_checkbox += '<input type="hidden" ' + _id_hidden + ' ' + _name + ' value="" >';		        		
        	}
        	else {
				_checkbox = '<input type="checkbox" class="cursorPointer kce_valigntop'; 
				 if (_additional_checkbox_classes != ''){
					_checkbox += ' ' + _additional_checkbox_classes; 
				 }
				 _checkbox += '"';
				
				if(_checked){
					_checkbox += ' checked '; 
				}
				_checkbox += _id_checkbox + '  ' + _name + ' >';		        		
        	}
							                
			var html = '<' + _element_type;
			 if (_additional_classes != ''){
				html += ' class="kce_nowrap ' + _additional_classes + '"'; 
			 }
			 else {
				html += ' class="kce_nowrap "'; 
			 }			 
			if(_hint != ''){
				html += ' title="' + _hint + '"';		
			}			 
			 html += '>';
			 
			if(_label_control) {
				var _label_control_caption = ''; //cb.data('label');
				if (typeof cb.data('label-control-caption') != 'undefined') {
					_label_control_caption = cb.data('label-control-caption');	
				}
				var _label_control_click = false;
				if (typeof cb.data('label-control-click') != 'undefined') {
					_label_control_click = cb.data('label-control-click');
				}					
						
				html += '<label class="konto-checkbox-control-label control-label ';
				if(_label_control_click) {
					html += ' cursorPointer" '  + _for;	
				}
				else {
					html += '" ';
				}
				html += ' >' + _label_control_caption + '&nbsp;</label>';
			}
			else {
				if(_align_bottom) {
					html += '<label class="konto-checkbox-control-label" ><br/></label>';
				}							
			}				

			html += '<' + _element_type;	
			
			html += ' class="konto-checkbox-main-label ';
			if(!_in_single_row){
				html += 'checkBoxTopPadding ';
			}
			
			if(_border) {
				html += ' form-control checkBoxBorder cursorPointer';
			}
			else {
				if(!_in_single_row){
					html += ' checkBoxFormControl';
				}
				html += ' borderTransparent';
			}
			
			if(_readonly_color) {	
				html += ' checkBoxLeftPadding height100';	
			}
			if(cb.hasClass("konto-readonly") && (_readonly_color)) {	
				html += ' colorReadonly';	
			}						
					
			html += '" >';
								
			if(_label_reverse) {
				html += _label + _checkbox;						
			}
			else {
				html += _checkbox + _label; 
			}
			
			html += '</' + _element_type + '>';

			html += '</' + _element_type + '>';
			
			cb.html(html);
			
			var cbi = cb.find('[type=checkbox]').first();
			var cbh = cb.find('[type=hidden]').first();
		
			var cbl_2 = cb.find('.konto-checkbox-label').first();
			
			if((!($.styleSheetExist('.uskiCSS'))) && (!(_border))) {
				cbl_2.addClass('checkBoxTopPaddingLabelFix');	
			}
			if(($.styleSheetExist('.uskiCSS')) && (_border)) {
				cbl_2.removeClass('checkBoxTopPaddingLabel');	
			}					
			
			if(_radio_look) {
				cbi.addClass('checkBoxRadioLook');
			}									
			
			cbi.on("click", function(e){
				if ($(this).isKontoReadonly()){
					KUtils.StopAllEvents(e);
    				return; 
	 			} 
				else {																								
		    		if (_value_reverse) {				    			
			     		if (cbi[0].checked) {
							cbh[0].value = 'off';
			    		}
			   			else {
			  				cbh[0].value = 'on';
		      			} 				    			
		    		}		
	    		}			    									
			});		

			var cbl_1 = cb.find('.konto-checkbox-main-label').first();	
				
			cbl_1.on("click", function(e){
				if ($(this).isKontoReadonly()){
    	        	KUtils.StopAllEvents(e);
    				return; 
	 			} 			
	 				
				var caller = e.target || e.srcElement;
																						
				if($(caller).hasClass('konto-checkbox-main-label')) {
					if(_border) {	
						cbi[0].checked = !(cbi[0].checked);
					}
					else {
						e.stopPropagation();
					}
				}						
			});							

			cbl_2.on("click", function(e){
				if ($(this).isKontoReadonly()){
    	        	KUtils.StopAllEvents(e);
    				return; 
	 			} 
	 							
				e.stopPropagation();
			});
			if(_label_control && _label_control_click) {
				var cbl_3 = cb.find('.konto-checkbox-control-label').first();	
				
				cbl_3.on("click", function(e){
					if ($(this).isKontoReadonly()){
	    	        	KUtils.StopAllEvents(e);
	    				return; 
		 			} 			
		 					
					e.stopPropagation();
				});						
			}    		
    	}, 
    	kontoCheckboxExtendedInit: function () {
			var cb = $(this);
								
			var _value_reverse = false;
			if (typeof cb.data('orm-reverse') != 'undefined') {
				_value_reverse = cb.data('orm-reverse');					
			}					
				
        	if (_value_reverse) {
				var cbi = cb.find('[type=checkbox]').first();
				var cbh = cb.find('[type=hidden]').first();
							        		
    			//Uncheck if checked, check if unchecked - REVERSE		        		
        		if (cbh[0].value == 'true') {
					cbi[0].checked = false;
        		}
        		else {
        			cbi[0].checked = true;
        		}
        	}	    		
    	},
    	isKontoCheckboxExtendedChecked: function () {				
			var cbi = $(this).find('[type=checkbox]').first();	        		
			return cbi[0].checked;		
    	},
        setKontoCheckboxExtendedChecked: function(flag){
        	if (typeof flag == 'undefined')
				flag = true;
			var cbi = $(this).find('[type=checkbox]').first();
			cbi.prop("checked", flag);					
        },
        setKCBELabel: function(_text){
        	$(this).find('label').text(_text);	
        },
        
		/**
		 * KONTO-MORE 
		 */    	
    	kontoMoreCreate: function () {
	 		var more = $(this);
	 		
	 		more.addClass("overflowHidden");
	 					 		
	 		var _obavijest = "";
			if (typeof more.data('obavijest') != 'undefined') {
				_obavijest = more.data('obavijest');					
			}	
			if (_obavijest == ""){
				_obavijest = more.html();
				more.data("obavijest", _obavijest);
				more.data("obavijest_default", _obavijest);
			}		 					 					 			
	 		
	 		var _caption = 'Više';
			if (typeof more.data('caption-more') != 'undefined') {
				_caption = more.data('caption-more');					
			}	
			
			var _short_text_length = 100;
			if (typeof more.data('short-text-length') != 'undefined') {
				_short_text_length = more.data('short-text-length');					
			}
								
			var _id = 'edKontoMore';
			if (typeof more.prop('id') != 'undefined') {
				_id = more.prop('id');					
			}						
								
			var _a_id = _id + '_a';							
			var _new_html = "<span class='konto-more-obavijest' >" + _obavijest + "</span>"; 
			_new_html += "&nbsp;&nbsp;<a id='" + _a_id + "' class='konto-more-a cursorPointer' >" + _caption + "</a>";							
			if (_obavijest.length > _short_text_length){
				_new_html = "<span class='konto-more-obavijest' >" + _obavijest.substring(0,_short_text_length - 1) + "</span>";
				_new_html += "&nbsp;&nbsp;<a id='" + _a_id + "' class='konto-more-a cursorPointer' >" + _caption + "</a>";		 									
			} 
								
			more.html(_new_html);	
			if (_obavijest == ""){
				var morea = more.find(".konto-more-a").first();
				morea.addClass("hide");	
			}	    		
    	},
    	kontoMoreChange: function () {
	 		var more = $(this);
	 		var morea = more.find(".konto-more-a").first();
	 		var moreo = more.find(".konto-more-obavijest").first();
	 		
		 	more.addClass("overflowHidden");
		 	more.removeClass("overflowShow");			 	
	 		
	 		var _obavijest = "";
			if (typeof more.data('obavijest') != 'undefined') {
				_obavijest = more.data('obavijest');					
			}	
			if (_obavijest == ""){
				_obavijest = more.data("obavijest_default");
				more.data("obavijest", _obavijest);
			}				
	 		
	 		var _caption = 'više...';
			if (typeof more.data('caption-more') != 'undefined') {
				_caption = more.data('caption-more');					
			}	
						 		
			var _short_text_length = 100;
			if (typeof more.data('short-text-length') != 'undefined') {
				_short_text_length = more.data('short-text-length');					
			}					
			
			var _new_html = _obavijest; 							
			if (_obavijest.length > _short_text_length){
				_new_html = _obavijest.substring(0,_short_text_length - 1);
				morea.removeClass("hide");		 									
			} 
			else {
				morea.addClass("hide");
			}						
									
			morea.html(_caption);
			moreo.html(_new_html);	    		
    	},
    	kontoMoreClick: function () {
	 		var morea = $(this);
	 		var more = morea.parent();
	 		var moreo = more.find(".konto-more-obavijest").first();
	 		
	 		var _obavijest = "";
			if (typeof more.data('obavijest') != 'undefined') {
				_obavijest = more.data('obavijest');					
			}				 		
	 		
	 		if (more.hasClass("overflowHidden")){
		 		more.removeClass("overflowHidden");
		 		more.addClass("overflowShow");
		 				
		 		var _caption = '...manje';
				if (typeof more.data('caption-less') != 'undefined') {
					_caption = more.data('caption-less');					
				}
		 		
		 		moreo.html(_obavijest);
		 		morea.html(_caption);					 			
	 		}
	 		else {
		 		var _caption = 'više...';
				if (typeof more.data('caption-more') != 'undefined') {
					_caption = more.data('caption-more');					
				}
							 			
		 		more.addClass("overflowHidden");
		 		more.removeClass("overflowShow");
		 		morea.html(_caption);
		 		more.trigger("change");			 			
	 		}    		
    	},   
    	
    	/**
		 * KONTO-RADIO-EXTENDED 
		 */    	
    	kontoRadioExtendedCreate: function () {
			var radio = $(this);
			var chale = radio.parent();
			var row = radio.closest('.row');
			
			_unique = $('#uniqueId').html();

			//ID
			var _id = '';
			var _id_radio = '';
			var _id_hidden = '';
			var _name_hidden = '';
			var _for = '';
			if (typeof radio.data('id') != 'undefined') {
				radio.prop('id', radio.data('id'));
				_id_radio = ' id="' + radio.data('id') + '_radio"'; 
				_id_hidden = ' id="' + radio.data('id') + '_hidden"'; 
				_name_hidden = ' name="' + radio.data('id') + '_hidden"'; 
				_for = ' for="' + radio.data('id') + '_radio"';
			}												

			//NAME - ZA POLJE KOJE IDE ORM-u
			var _name = '';
			if (typeof radio.data('orm-name') != 'undefined') {
				_name = ' name="' + radio.data('orm-name') + '"';						
			}
					
			var _border = true;
			if (typeof radio.data('border') != 'undefined') {
				_border = radio.data('border');					
			}
			
			var _default = 0;
			if (typeof radio.data('default') != 'undefined') {
				_default = radio.data('default');					
			}					
															
			var _cols = '';
			if (typeof radio.data('cols') != 'undefined') {
				_cols = parseInt(radio.data('cols'));	
				
				if(_cols < 1) _cols = 1;
				if(_cols > 12) _cols = 12;					
			}													
					
			var items_count = 0;				
			var _use_fields = false;
			var _fields = new Array;
			var _values = new Array;
			var _captions = new Array;	
			var _field_name = 'field-1';						
			var _value_name = 'value-1';
			var _caption_name = 'caption-1';
				
			do {
				if (typeof radio.data(_field_name) != 'undefined') {
					_fields[items_count] = radio.data(_field_name);		
					_use_fields = true;		
				}				
				else {
					_fields[items_count] = '';
				}		
				if (typeof radio.data(_value_name) != 'undefined') {
					_values[items_count] = radio.data(_value_name);		
				}				
				else {
					_values[items_count] = '';
				}							
				if (typeof radio.data(_caption_name) != 'undefined') {
					_captions[items_count] = radio.data(_caption_name);	
				}				
				else {
					_captions[items_count] = '';
				}												
				
				items_count++;	
				_field_name = 'field-' + (items_count+1);					
				_value_name = 'value-' + (items_count+1);
				_caption_name = 'caption-' + (items_count+1);
			}
			while (typeof radio.data(_caption_name) != 'undefined'); 
			
			var _element_type = 'div';
			
			var _additional_classes = '';
			if (typeof radio.data('additional-classes') != 'undefined') {	
				_additional_classes = radio.data('additional-classes');
			}					
			
			var _label_control = false;
			if (typeof radio.data('label-control') != 'undefined') {
				_label_control = radio.data('label-control');
			}						
			
			var html = '<' + _element_type;
			html += ' class="form-group ';				
			html += _additional_classes + '"'; 
			html += ' >';
												
			if(_label_control) {
				var _label_control_caption = ''; 
				if (typeof radio.data('label-control-caption') != 'undefined') {
					_label_control_caption = radio.data('label-control-caption');	
				}
				var _label_control_click = false;
				if (typeof radio.data('label-control-click') != 'undefined') {
					_label_control_click = radio.data('label-control-click');
				}					
						
				html += '<label class="konto-radio-control-label control-label ';
				if(_label_control_click) {
					html += ' cursorPointer" '  + _for;	
				}
				else {
					html += '" ';
				}
				html += ' >' + _label_control_caption + '&nbsp;</label>';
			}										
	 		 
			html += '<div class="konto-radio';
			if(!(_border)){
				html += ' borderTransparent';						
			}						
			html += '" ' + _id + ' >';
			
			html += '<input type="hidden" ' + _id_hidden + ' ' + _name + ' value="" />';					
			html += '<input type="hidden" id="edUseFields-' + _unique + '" value="' + _use_fields + '" />';
			html += '<input type="hidden" id="edDefault-' + _unique + '" value="' + _default + '" />';
			if (_use_fields) {
				for(i=0; i<items_count; i++) {
					var _field_clean = _fields[i].replace(':','_').replace('[','_').replace(']','').replace('\\','_').replace('/','_');
					html += '<input type="hidden" id="ed' + _field_clean + '-' + _unique + '" name="' + _fields[i] + '" data-krbex="true" value="0" />';
				}	
			}				
			
			var bootstrap_cols;
			if(_cols != ''){
				bootstrap_cols = parseInt(12/_cols);	
			}
			else {
				if (items_count > 12) {
					bootstrap_cols = 1;	
				}
				else {
					bootstrap_cols = parseInt(12/items_count);
				}
			}
						
			html += '<div class="row">';										
			for(i=0; i<items_count; i++) {												
				html += '<div class="col-md-' + bootstrap_cols + '">';						
				html += '<label class="radio-inline">';
				html += '<div class="radioInline"><input type="radio" ' + _name_hidden;
				if (_use_fields) {
					html += ' class="ed' + _fields[i] + '"';
				}
				else {					
					html += ' value="' + _values[i];
				}
					
				html += '">' + _captions[i] + '</div>';
				html += '</label>';
				html += '</div>';
				
				//konzultacije s tihom - zašto je ovdje 3 ... ako imamo cols = 5 onda stavi bootstrap_cols = 2, i iza 4 stavke prebaci u novi red, to nije OK  
				//if((i % _cols) == 3) {
				if ( ((i + 1) % (_cols)) == 0 ){
					html += '</div>';
					html += '<div class="row">';	
				}
						
			}	
			html += '</div>';
			
			html += '</div>';					
			html += '</' + _element_type + '>';					

			radio.html(html);	    		
    	},
    	kontoRadioExtendedInit: function () {
    		group = $(this);	    			
    		_unique = $('#uniqueId').html();    		
    		_use_fields = $("#edUseFields-" + _unique, group).first().val();
    		_use_default = true;    		
		  		
    		if (_use_fields == "true") {
	    		$("input[type=radio]", group).each(function(){
	    			radio = $(this);
	    			field = $("#" + radio.attr("class") + "-" + _unique);
	   				value = field.val();

	    			if ((value == "true") || (value == "one") || (value == "1")){
	    				radio.attr("checked", "");
	    				field.val("1");
	    				_use_default = false;
	    			} 
	    			else {
	    				field.val("0");	
	    			} 			    				
	    			radio.on("click",function(){		
	    				$(this).closest('.form-group').find('input[type=radio]').each(function(){
	    					var _field = $(this).attr("class");
	    					var _field_clean = _field.replace(':','_').replace('[','_').replace(']','').replace('\\','_').replace('/','_');			    					
	    					field2 = $("#" + _field_clean + "-" + _unique);
	    					field2.val("0");
	    				});
	    				var _field = $(this).attr("class");
	    				var _field_clean = _field.replace(':','_').replace('[','_').replace(']','').replace('\\','_').replace('/','_');
	    									    				
	    				field3 = $("#" + _field_clean + "-" + _unique);		    				    				
	    				field3.val("1");		
	    			});
    			});		    			
    		}	
    		else {
    			input = $("input[type=hidden]", group);
    					    		
	    		$("input[type=radio]", group).each(function(){
	    			radio = $(this);
	    			if (radio.val() == input.val() ){
	    				radio.attr("checked", "");
	    				_use_default = false;
	    			}  			    				
	    			radio.on("click",function(){
	    				$(this).closest('.form-group').find('input[type=hidden]').first().val( $(this).val() );					
	    			});
    			});
			}
			
			if (_use_default) {
				_default = $("#edDefault-" + _unique, group).first().val();
				
				if (_default != 0) {
					_items = 1;
					
					$("input[type=radio]", group).each(function(){
	    				radio = $(this);
	    				if (_use_fields == "true"){
	    				    field4 = $("#" + radio.attr("class") + "-" + _unique);
    	    				if (_items == _default){
    	    					radio.attr("checked", "");
    	    					field4.val("1");
    	    				}
    	    				else {
    	    					field4.val("0");	
    	    				}
	    				}else{
	    				    if (_items == _default){
	    				       $("#" + group.prop('id') + '_hidden').val(radio.attr("checked", "").val());
	    				    }    
	    				}
	    				_items++;
    			    });
				}
			}    		
    	},
    	getRadioValue: function () {				
			rez = undefined;
			group = $(this);
			
			$("input[type=radio]", group).each(function(){
				radio = $(this);
				if (radio[0].checked){
					rez = radio[0].value;
				}
			});
			return rez;
    	},
        setRadioValue: function(val){
			group = $(this);			
			$("input[type=radio]", group).each(function(){
				radio = $(this);
				if (radio[0].value == val){
		    		_unique = $('#uniqueId').html();    		
		    		_use_fields = $("#edUseFields-" + _unique, group).first().val();					
					
		    		if (_use_fields == "true") {	    				
	    				$(this).closest('.form-group').find('input[type=radio]').each(function(){
	    					var _field = $(this).attr("class");
	    					var _field_clean = _field.replace(':','_').replace('[','_').replace(']','').replace('\\','_').replace('/','_');			    					
	    					field2 = $("#" + _field_clean + "-" + _unique);
	    					field2.val("0");
	    				});
	    				var _field = $(this).attr("class");
	    				var _field_clean = _field.replace(':','_').replace('[','_').replace(']','').replace('\\','_').replace('/','_');
	    									    				
	    				field3 = $("#" + _field_clean + "-" + _unique);		    				    				
	    				field3.val("1");		
		    		}
	    			else{
						radio.closest('.form-group').find('input[type=hidden]').first().val( $(this).val() );    				
	    			}					
				}
			});					
        }, 
        setReadonlyRadioValue: function(val, flag){
			if (typeof flag == 'undefined')
				flag = true;
			group = $(this);			
			$("input[type=radio]", group).each(function(){
				radio = $(this);									
				if (radio[0].value == val){
					if (flag){
						$(this).addClass("konto-readonly");
						$(this).addClass("cursorNotAllowed");
						$(this).addClass("nonClickable");
						$(this).prop("disabled", "disabled");
						$(this).closest('.radio-inline').addClass("cursorNotAllowed");	
					}else{
						$(this).removeClass("konto-readonly");
						$(this).removeClass("cursorNotAllowed");
						$(this).removeClass("nonClickable");
						$(this).prop("disabled", false);
						$(this).closest('.radio-inline').removeClass("cursorNotAllowed");	
					}				
				}
			});			
		},
		setReadonlyRadioFiled: function(fieldName, flag){
			if (typeof flag == 'undefined')
				flag = true;
    		group = $(this);
    		$("input[type=radio]", group).each(function(){
				radio = $(this);
				if (radio.hasClass('ed'+fieldName)){
					if (flag){
						$(this).addClass("konto-readonly");
						$(this).addClass("cursorNotAllowed");
						$(this).addClass("nonClickable");
						$(this).prop("disabled", "disabled");
						$(this).closest('.radio-inline').addClass("cursorNotAllowed");
					}else{
						$(this).removeClass("konto-readonly");
						$(this).removeClass("cursorNotAllowed");
						$(this).removeClass("nonClickable");
						$(this).prop("disabled", false);
						$(this).closest('.radio-inline').removeClass("cursorNotAllowed");
					}
				}	
			});
		},	
    	isRadioFiledChecked: function (fieldName) {
    		group = $(this);
    		rez = undefined;
    		$("input[type=radio]", group).each(function(){
	    		radio = $(this);
	    		var el = radio.closest('.konto-radio-extended');	    		
	    		var isReadonly = el.hasClass('konto-readonly');
	    		if(isReadonly){
	    			radio.attr('disabled', false);
	    		}	    		
	    		if (radio.hasClass('ed'+fieldName)){
	    			rez = radio[0].checked;	
	    		}
	    		if(isReadonly){
	    			radio.attr('disabled', true);
	    		}	    		
	    	});
    		return rez;
    	},
    	setRadioFiledChecked: function(fieldName){
    		group = $(this);
    		$("input[type=radio]", group).each(function(){
	    		radio = $(this);
    		
	    		if (radio.hasClass('ed'+fieldName)){
    				$(this).closest('.form-group').find('input[type=radio]').each(function(){
    					var _field = $(this).attr("class");
    					var _field_clean = _field.replace(':','_').replace('[','_').replace(']','').replace('\\','_').replace('/','_');			    					
    					field2 = $("#" + _field_clean + "-" + _unique);
    					field2.val("0");
    				});
    				var _field = $(this).attr("class");
    				var _field_clean = _field.replace(':','_').replace('[','_').replace(']','').replace('\\','_').replace('/','_');
    									    				
    				field3 = $("#" + _field_clean + "-" + _unique);		    				    				
    				field3.val("1");	    		
	    			this.checked = true;
	    		}		    		
	    	});
    	},
		kontoRadioExtendedFixValueOnClickOverride: function(){
			$(this).closest('.form-group').find('input[type=hidden]').first().val( $(this).val() );	
		},
    	
    	/**
		 * KONTO-DATETIME-SEPARATE 
		 */ 
		kontoDateTimeSeparateHide: function () {
			$(this).addClass("hide");  			
		},
    	kontoDateTimeSeparateCreate: function () {	
	        var name = $(this).prop("name");         		           		
     		var name_date = "_datepart_" + name + "_";
     		var name_time = "_timepart_" + name + "_";
     		
     		if($(this).attr("readonly")) {
     			var readonly = "readonly";
     		}
     		else {
     			var readonly = "";
     		}
     		
     		if($(this).attr("disabled")) {
     			var disabled = "disabled";
     		}
     		else {
     			var disabled = "";
     		}             		
     		
     		//dodatak za polja
     		var field_index = name.indexOf("[");
     		if(field_index != -1) {
     			var name_parts = name.split("[");
     			name_date = "_datepart_" + name_parts[0] + "_" + name.substring(field_index, name.length);
     			name_time = "_timepart_" + name_parts[0] + "_" + name.substring(field_index, name.length);
     		}
     		            		
     		var this_class = $(this).prop("class");
     		var width_similar_to = $(this).data("width-similar-to");       		
			          		             		             		
     		var height_fix = $(this).closest("div.form-group").height();
     		var width_fix = 32;
     		
     		var elements_to_add = '<div class="k-state_default" >';            		
     		if(this_class.indexOf("konto-hide-date") != -1) {
     			elements_to_add += '<div class="dateDiv" style="position:relative; float:left;" ><input type="text" name="' + name_date + '" ';
     			elements_to_add += ' class="konto-input-date konto-input-date-separate hide';
     			elements_to_add += '" autocomplete="off" ' + readonly + ' ' + disabled + ' data-role="maskedtextbox" /></div>';    
     			//elements_to_add += '<div style="position:relative; float:left;" >&nbsp;</div>';  
     			width_fix = 100;           			         		             			
     		}
     		else {
     			elements_to_add += '<div class="dateDiv" style="position:relative; float:left; width: 60%;" ><input type="text" name="' + name_date + '" ';
     			elements_to_add += ' class="konto-input-date konto-input-date-separate ';
     			elements_to_add += '" autocomplete="off" ' + readonly + ' ' + disabled + ' data-role="maskedtextbox" /></div>';             		             			
     			elements_to_add += '<div style="position:relative; float:left; width: 8%;" >&nbsp;</div>';
     		}
     		            				             	
     		if(this_class.indexOf("konto-input-datetime-ss") == -1) {
    			//nema sekunde
     			elements_to_add += '<div class="timeDiv" style="position:relative; float:left; width: ' + width_fix + '%;" ><input type="text" name="' + name_time + '" ';
         		if(this_class.indexOf("konto-hide-time-picker") != -1) {
         			elements_to_add += ' class="form-control konto-hide-time-picker konto-input-time-separate"';	
         		}
         		else {
         			elements_to_add += ' class="konto-input-time konto-input-time-separate"';		
         		}
     			elements_to_add += ' style="text-align: left;" autocomplete="off" ' + readonly + ' ' + disabled + ' data-role="maskedtextbox" /></div>';
     		}
     		else {
     			//ima sekunde
     			elements_to_add += '<div class="timeDiv" style="position:relative; float:left; width: ' + width_fix + '%;" ><input type="text" name="' + name_time + '" ';
         		if(this_class.indexOf("konto-hide-time-ss-picker") != -1) {
         			elements_to_add += ' class="form-control konto-hide-time-ss-picker konto-input-time-separate"';	
         		}
         		else {
         			elements_to_add += ' class="konto-input-time-ss konto-input-time-ss-separate"';		
         		}             			
     			elements_to_add += ' style="text-align: left;" autocomplete="off" ' + readonly + ' ' + disabled + ' data-role="maskedtextbox" /></div>';
     		}

     		elements_to_add += '</div>';           		   
      		 
      		//dodaj nova polja 					 					             			
			var form_group = $(this).parents('.form-group').first();
 			var time_label = form_group.find('label.time-control-label').first();
 			if(time_label.length == 1){
     			var date_label = form_group.find('label.control-label').first();
     			var time_text = time_label[0].outerHTML;	
     			var date_text = date_label[0].outerHTML;
     			time_text = time_text.replace('time-control-label', 'control-label');
     			date_label.remove();  
     			time_label.remove();
     			if(this_class.indexOf("konto-hide-date") != -1) {
     				form_group.append('<div class="dateDiv" style="position:relative; float:left; " >' + date_text + '</div>' +
     				'<div class="timeDiv" style="position:relative; float:left; width: ' + width_fix + '%;" >' + time_text + '</div>');
     			}
     			else {
     				form_group.append('<div class="dateDiv" style="position:relative; float:left; width: 60%;" >' + date_text + '</div>' +
     				'<div style="position:relative; float:left; width: 8%;" >&nbsp;</div>' +
     				'<div class="timeDiv" style="position:relative; float:left; width: ' + width_fix + '%;" >' + time_text + '</div>');			
     			}          				
 			}					        			
     		form_group.append(elements_to_add); 					
					 					
			$(this).removeClass("konto-hide-time-picker");
			$(this).removeClass("konto-hide-time-ss-picker");
			
			//fix height 
			$(this).closest("div.form-group").height(height_fix);	
			
			//fix width
			if(width_similar_to){
				var oldPolje = $("input." + width_similar_to);	
				var old_form_group = oldPolje.parents('.form-group').first();	
				var oldDateDiv = old_form_group.find("div.dateDiv");
				var new_date_width = oldDateDiv.width(); 
				var oldTimeDiv = old_form_group.find("div.timeDiv");
				var new_time_width = oldTimeDiv.width(); 
				var dateDiv = form_group.find("div.dateDiv"); 						
				var timeDiv = form_group.find("div.timeDiv");  
																			
     			if(this_class.indexOf("konto-hide-date") != -1) {						
					if(new_time_width){
						timeDiv.width(new_time_width);							
					}
     			}
     			else {
					if(new_date_width){
						dateDiv.width(new_date_width);							
					}	         				
					if(new_time_width){
						timeDiv.width(new_time_width);							
					}	         				
     			}
			}
    	},
    	kontoDateTimeSeparateInit: function () {
 			var value = $(this).val();
 			var name = $(this).prop("name");
 			
 			var value_date = value.substring(0,10);
 			
 			var name_date = "_datepart_" + name + "_";
 			var name_time = "_timepart_" + name + "_";
 		
 			//dodatak za polja
 			var field_index = name.indexOf("[");
 			if(field_index != -1)
 			{
 				var name_parts = name.split("[");
 				name_date = "_datepart_" + name_parts[0] + "_" + name.substring(field_index, name.length);
 				name_time = "_timepart_" + name_parts[0] + "_" + name.substring(field_index, name.length);
 			}
 			
 			//korekcija za backslash i jquery
			var backslash = String.fromCharCode(92);
			var backslash2 = String.fromCharCode(92) + String.fromCharCode(92);           			            		
 			if(name_date.indexOf(backslash) != -1)
 			{
 				name_date = name_date.split(backslash).join(backslash2);   
 			}  
 			if(name_time.indexOf(backslash) != -1)
 			{
 				name_time = name_time.split(backslash).join(backslash2);   
 			}  
 			
 			var datePolje = $(this).closest("div.form-group").parent().find("input[name$='" + name_date + "']"); 
 			var timePolje = $(this).closest("div.form-group").parent().find("input[name$='" + name_time + "']");            			
 			
 			datePolje.val(value_date);
 			datePolje.data("hasKontoEnterNavigation", true);
 			
 			var this_class = $(this).prop("class");
			if(this_class.indexOf("konto-input-datetime-ss") == -1)
			{
				var value_time = value.substring(11,16);
			}							
			else
			{
				var value_time = value.substring(11,19);
			}
			
			timePolje.val(value_time); 
			timePolje.data("hasKontoEnterNavigation", true);  
								
			//set old value	
			$(this).data("konto_old_value", value);	      		
    	},
    	kontoDateTimeSeparateSubmit: function () {
 			var name = $(this).prop("name");     
 			
 			var name_date = "_datepart_" + name + "_";
 			var name_time = "_timepart_" + name + "_";
 		
 			//dodatak za polja
 			var field_index = name.indexOf("[");
 			if(field_index != -1)
 			{
 				var name_parts = name.split("[");
 				name_date = "_datepart_" + name_parts[0] + "_" + name.substring(field_index, name.length);
 				name_time = "_timepart_" + name_parts[0] + "_" + name.substring(field_index, name.length);              				
 			}             		
 			
 			//korekcija za backslash i jquery
			var backslash = String.fromCharCode(92);
			var backslash2 = String.fromCharCode(92) + String.fromCharCode(92);           			            		
 			if(name_date.indexOf(backslash) != -1)
 			{
 				name_date = name_date.split(backslash).join(backslash2);   
 			}   
 			if(name_time.indexOf(backslash) != -1)
 			{
 				name_time = name_time.split(backslash).join(backslash2);   
 			}               				   	
 			     
 			var old_val = $(this).val();     			
 			var datePolje = $(this).closest("div.form-group").parent().find("input[name$='" + name_date + "']"); 
 			var timePolje = $(this).closest("div.form-group").parent().find("input[name$='" + name_time + "']");                 			
 			
 			var value_date = datePolje.val();             			
 			if(value_date == "")
 			{
 				//korekcija za prazno
 				value_date = old_val.substring(0,10);
 				datePolje.val(value_date);	
 			}
 			
 			var this_class = $(this).prop("class");
			if(this_class.indexOf("konto-input-datetime-ss") == -1)
			{           				
				var old_sec = ""; // + kendo.toString(kendo_value, "mm"); kendo value ne radi ima null   				
				var value_time = timePolje.val() + old_sec;
 				if(value_time == "")
 				{
 					//korekcija za prazno
 					value_time = old_val.substring(11,16);
					timePolje.val(value_time);             					
 				}            				
			}							
			else
			{
				var value_time = timePolje.val();
 				if(value_time == "")
 				{
 					//korekcija za prazno
 					value_time = old_val.substring(11,19);
					timePolje.val(value_time);             					
 				}             				
			}
			
			//Ne treba jer to odradi blur 
			//var new_val = value_date + " "+ value_time;
			//$(this).val(new_val);    		
    	},
    	kontoDateSeparateFocus: function (e) {
 			var name = $(this).prop("name");
			            		
 			//dodatak za polja
 			var field_index = name.indexOf("[");
 			if(field_index != -1)
 			{
 				var new_name = name.substring(10,field_index -1) + name.substring(field_index, name.length);
 			}            			            		
			else   
			{
				var new_name = name.substring(10,name.length -1);
			}     
			
   			//korekcija za backslash i jquery
			var backslash = String.fromCharCode(92);
			var backslash2 = String.fromCharCode(92) + String.fromCharCode(92);           			            		
 			if(new_name.indexOf(backslash) != -1)
 			{
 				new_name = new_name.split(backslash).join(backslash2);   
 			}   
			
 			var datetimePolje = $(this).closest("div.form-group").parent().find("input[name$='" + new_name + "']");
 			             			
 			var myFunc = datetimePolje.data("date_focus_function");            			
 			if(myFunc == undefined) myFunc = datetimePolje.data("focus_function");           			
 			if(myFunc == undefined) return false;             			
 			
 			var myParameters = datetimePolje.data("date_focus_parameters");
 			if(myParameters == undefined) myParameters = datetimePolje.data("focus_parameters");             			            			
 			if(myParameters == undefined)
 			{
 				KUtils.runFunction(myFunc, e);
 			}
 			else
 			{
 				KUtils.runFunction(myFunc, myParameters);	
 			}    		
    	},
    	kontoDateSeparateBlur: function (e) {
 			var name = $(this).prop("name");

 			//dodatak za polja
 			var field_index = name.indexOf("[");
 			if(field_index != -1)
 			{
 				var new_name = name.substring(10,field_index -1) + name.substring(field_index, name.length);
 			}            			            		
			else   
			{
				var new_name = name.substring(10,name.length -1);
			}     
			
   			//korekcija za backslash i jquery
			var backslash = String.fromCharCode(92);
			var backslash2 = String.fromCharCode(92) + String.fromCharCode(92);           			            		
 			if(new_name.indexOf(backslash) != -1)
 			{
 				new_name = new_name.split(backslash).join(backslash2);   
 			}   
			
 			var datetimePolje = $(this).closest("div.form-group").parent().find("input[name$='" + new_name + "']");          			
			
 			var old_val = datetimePolje.val();
 			var this_val = $(this).val();
 			if(old_val)
 			{
 				var new_val = this_val.substring(0,10) + old_val.substring(10,old_val.length);
 			}
 			else
 			{
 				var new_val = this_val.substring(0,10) + " __:__";
 			}
 			
 			//BRISANJE VRIJEDNOSTI
 			if(this_val == "")
 			{
 				var new_val = ""; 
 				//brisanje vremena
 				var name_time = "_timepart_" + name.substring(10,name.length);
 				var timePolje = $(this).closest("div.form-group").parent().find("input[name$='" + name_time + "']");       
 				var new_time = timePolje.val();    
         				
         		if(new_time == "") new_time = "__:__";  		
         				
 				var new_val = "__.__.____ " + new_time;   
 				
 				if(new_val == "__.__.____ __:__") timePolje.val(""); 
 			}
 			
 			if(old_val != new_val)
 			{
 				//change event   
 				datetimePolje.data("konto_old_value", old_val);
 				           				
 				var myFunc = datetimePolje.data("date_change_function");            			
 				if(myFunc == undefined) myFunc = datetimePolje.data("change_function");          				           			
 				if(myFunc != undefined)
 				{             			
 					var myParameters = datetimePolje.data("date_change_parameters");
 					if(myParameters == undefined) myParameters = datetimePolje.data("change_parameters");             			            			
 					if(myParameters == undefined)
 					{
 						KUtils.runFunction(myFunc, e);
 					}
 					else
 					{
 						KUtils.runFunction(myFunc, myParameters);	
 					}    
 				}          				   				
 				
 				$(this).data("blur", false); //napravi i blur	
 				$(this).data("mouseblur", true); //ne i mouse blur  
 				datetimePolje.val(new_val);         				            				
 				datetimePolje.trigger("change");       				             				
 			} 

 			//blur event
			if(($(this).data("blur") == false))
			{ 
 				var myFunc = datetimePolje.data("date_blur_function");            			
 				if(myFunc == undefined) myFunc = datetimePolje.data("blur_function");           				           			
 				if(myFunc != undefined)
 				{             			
 					var myParameters = datetimePolje.data("date_blur_parameters");
 					if(myParameters == undefined) myParameters = datetimePolje.data("blur_parameters");             			            			
 					if(myParameters == undefined)
 					{
 						KUtils.runFunction(myFunc, e);
 					}
 					else
 					{
 						KUtils.runFunction(myFunc, myParameters);	
 					}    
 				}   							
											
				//Izvrši blur								
				$(this).data("blur", true);	   
				$(this).data("mouseblur", true);	            			
 				datetimePolje.trigger("blur");
 			}        
			if($(this).data("mouseblur") == false)
			{
				$(this).data("blur", true);	 
				$(this).data("mouseblur", true);							            			
 				datetimePolje.trigger("blur");							
			}      		
    	},
    	kontoDateSeparateChange: function (e) {
    		$(this).trigger("blur");
    	},    	
    	kontoDateSeparateKeyDown: function (root, e) {
    		var key = e.which || e.charCode || e.keyCode;    

    		if(key == 9)
    		{
    			$(this).data("blur", true); //nemoj napraviti blur izvrsiti ce se na timeu
    			$(this).data("mouseblur", true);
    		}                		           		
    		
			if((key == 13) && ($(this).data("hasKontoEnterNavigation"))){
      			var focusable = root.find("input,a,select,button,textarea")
        			.filter(":visible")
        			.filter(":not(:disabled)")
        			.filter(":not([readonly])")
					.filter(":not(.skipEnterTab)")
        			.filter(':not(.konto-readonly)');
    			var next = focusable.eq(focusable.index(this)+1);
    			if (next.length === 0) {
        			if (focusable.length === 0)
            			return false;
        			next = focusable.eq(0);
    			}         
				$(this).data("blur", false); //izvrši blur
				$(this).data("mouseblur", true);							                			       
    			next.focus().select();                			
			}      		
    	},
    	kontoDateSeparateMouseDown: function () {
    		$(this).data("mouseblur", true);
    	},  
    	kontoDateSeparateMouseUp: function () {
    		$(this).data("mouseblur", false);
    	},  
    	kontoDateSeparateEach: function () {
 			$(this).removeClass("k-input");
 			$(this).parents(".form-group").removeClass("has-error");  
 			
 			//dodaj kontrole evenata
			$(this).data("blur", false);	
			$(this).data("mouseblur", false); 
    	},
    	kontoTimeSeparateFocus: function (e) {
 			var name = $(this).prop("name");
			            		
 			//dodatak za polja
 			var field_index = name.indexOf("[");
 			if(field_index != -1)
 			{
 				var new_name = name.substring(10,field_index -1) + name.substring(field_index, name.length);
 			}            			            		
			else   
			{
				var new_name = name.substring(10,name.length -1);
			}     
			
   			//korekcija za backslash i jquery
			var backslash = String.fromCharCode(92);
			var backslash2 = String.fromCharCode(92) + String.fromCharCode(92);           			            		
 			if(new_name.indexOf(backslash) != -1)
 			{
 				new_name = new_name.split(backslash).join(backslash2);   
 			}   
			
 			var datetimePolje = $(this).closest("div.form-group").parent().find("input[name$='" + new_name + "']");
 			             			
 			var myFunc = datetimePolje.data("time_focus_function");
 			if(myFunc == undefined) myFunc = datetimePolje.data("focus_function");                			
 			if(myFunc == undefined) return false;             			         			
 			
 			var myParameters = datetimePolje.data("time_focus_parameters");
 			if(myParameters == undefined) myParameters = datetimePolje.data("focus_parameters");             			            			
 			if(myParameters == undefined)
 			{
 				KUtils.runFunction(myFunc, e);
 			}
 			else
 			{
 				KUtils.runFunction(myFunc, myParameters);	
 			}    		
    	},
    	kontoTimeSeparateBlur: function (e) {
 			var name = $(this).prop("name");

 			//dodatak za polja
 			var field_index = name.indexOf("[");
 			if(field_index != -1)
 			{
 				var new_name = name.substring(10,field_index -1) + name.substring(field_index, name.length);
 			}            			            		
			else   
			{
				var new_name = name.substring(10,name.length -1);
			} 
			      
   			//korekcija za backslash i jquery
			var backslash = String.fromCharCode(92);
			var backslash2 = String.fromCharCode(92) + String.fromCharCode(92);           			            		
 			if(new_name.indexOf(backslash) != -1)
 			{
 				new_name = new_name.split(backslash).join(backslash2);   
 			}   
 			
 			var datetimePolje = $(this).closest("div.form-group").parent().find("input[name$='" + new_name + "']");
 			
 			var old_val = datetimePolje.val();
 			var this_val = $(this).val();
 			if(old_val)
 			{
 				var new_val = old_val.substring(0,10) + " " + this_val;
 			}
 			else
 			{
 				/* Ukoliko želimo današnji dan
 				var new_date = KUtils.formatDate(new Date());          				             				
 				var name_date = "_datepart_" + name.substring(10,name.length);
 				var datePolje = $(this).closest("div.form-group").parent().find("input[name$='" + name_date + "']");       
 				datePolje.val(new_date);  
 				   */
 				            				             				
 				var new_val = "__.__.____ " + this_val;
 			}           			
 			
 			//BRISANJE VRIJEDNOSTI
 			if(this_val == "")
 			{
 				var name_date = "_datepart_" + name.substring(10,name.length);
 				var datePolje = $(this).closest("div.form-group").parent().find("input[name$='" + name_date + "']");       
 				var new_date = datePolje.val(); 
 				
           		if(new_date == "") new_date = "__.__.____"; 
 				
 				var new_val = new_date + " __:__";    
 				
 				if(new_val == "__.__.____ __:__") datePolje.val("");   
 				           				
 				if(datetimePolje.prop("class").indexOf("konto-hide-date") != -1)
 				{
 					new_val = ""; //"__.__.____ __:__";             					            										
 				}             				      				         				
 			}
 			             			
 			if(old_val != new_val)
 			{
 				//change event
 				datetimePolje.data("konto_old_value", old_val);
 				        
 				var myFunc = datetimePolje.data("time_change_function");            			
 				if(myFunc == undefined) myFunc = datetimePolje.data("change_function");            				           			
 				if(myFunc != undefined)
 				{             			
 					var myParameters = datetimePolje.data("time_change_parameters");
 					if(myParameters == undefined) myParameters = datetimePolje.data("change_parameters");             			            			
 					if(myParameters == undefined)
 					{
 						KUtils.runFunction(myFunc, e);
 					}
 					else
 					{
 						KUtils.runFunction(myFunc, myParameters);	
 					}    
 				}               				        
 				             				
 				$(this).data("blur", false); //napravi i blur	 
 				$(this).data("mouseblur", true); //ne i mouse blur            				
 				datetimePolje.val(new_val);
 				datetimePolje.trigger("change");    
 			} 
 			          			
 			//blur event
			if(($(this).data("blur") == false))
			{
 				var myFunc = datetimePolje.data("time_blur_function");            			
 				if(myFunc == undefined) myFunc = datetimePolje.data("blur_function");            				           			
 				if(myFunc != undefined)
 				{             			
 					var myParameters = datetimePolje.data("time_blur_parameters");
 					if(myParameters == undefined) myParameters = datetimePolje.data("blur_parameters");             			            			
 					if(myParameters == undefined)
 					{
 						KUtils.runFunction(myFunc, e);
 					}
 					else
 					{
 						KUtils.runFunction(myFunc, myParameters);	
 					}    
 				}   							
											
				//Izvrši blur									
				$(this).data("blur", true);	
				$(this).data("mouseblur", true);							             			
 				datetimePolje.trigger("blur");
 			}     
			if($(this).data("mouseblur") == false)
			{
				$(this).data("blur", true);	 
				$(this).data("mouseblur", true);							            			
 				datetimePolje.trigger("blur");							
			}     		
    	},
    	kontoTimeSeparateChange: function (e) {
    		$(this).trigger("blur");
    	},
    	kontoTimeSeparateKeyDown: function (root, e) {
    		var key = e.which || e.charCode || e.keyCode;
		
    		if(key == 9)
    		{
    			$(this).data("blur", false); //napravi i blur		
    			$(this).data("mouseblur", true); //ne i mouse blur                			
    		}
    		
			if((key == 13) && ($(this).data("hasKontoEnterNavigation"))){
      			var focusable = root.find("input,a,select,button,textarea")
        			.filter(":visible")
        			.filter(":not(:disabled)")
        			.filter(":not([readonly])")
					.filter(":not(.skipEnterTab)")
        			.filter(':not(.konto-readonly)');
    			var next = focusable.eq(focusable.index(this)+1);
    			if (next.length === 0) {
        			if (focusable.length === 0)
            			return false;
        			next = focusable.eq(0);
    			}                
				$(this).data("blur", false); //napravi i blur	
    			$(this).data("mouseblur", true); //ne i mouse blur  
    			next.focus().select();
			}      		
    	},
    	kontoTimeSeparateMouseDown: function () {
			$(this).data("mouseblur", true);
    	},
    	kontoTimeSeparateMouseUp: function () {
			$(this).data("mouseblur", false);
    	},
    	kontoTimeSeparateEach: function () {
 			$(this).removeClass("k-input");      
 			            			
 			//dodaj kontrole evenata
			$(this).data("blur", false);	
			$(this).data("mouseblur", false);	
    	},
    	kontoTimeSSSeparateFocus: function (e) {
 			var name = $(this).prop("name");
			            		
 			//dodatak za polja
 			var field_index = name.indexOf("[");
 			if(field_index != -1)
 			{
 				var new_name = name.substring(10,field_index -1) + name.substring(field_index, name.length);
 			}            			            		
			else   
			{
				var new_name = name.substring(10,name.length -1);
			}     
			
   			//korekcija za backslash i jquery
			var backslash = String.fromCharCode(92);
			var backslash2 = String.fromCharCode(92) + String.fromCharCode(92);           			            		
 			if(new_name.indexOf(backslash) != -1)
 			{
 				new_name = new_name.split(backslash).join(backslash2);   
 			}   
			
 			var datetimePolje = $(this).closest("div.form-group").parent().find("input[name$='" + new_name + "']");
 			             			
 			var myFunc = datetimePolje.data("time_focus_function");
 			if(myFunc == undefined) myFunc = datetimePolje.data("focus_function");             			            			
 			if(myFunc == undefined) return false;
 			
 			var myParameters = datetimePolje.data("time_focus_parameters");
 			if(myParameters == undefined) myParameters = datetimePolje.data("focus_parameters");             			            			
 			if(myParameters == undefined)
 			{
 				KUtils.runFunction(myFunc, e);
 			}
 			else
 			{
 				KUtils.runFunction(myFunc, myParameters);	
 			}    		
    	},
    	kontoTimeSSSeparateBlur: function (e) {
 			var name = $(this).prop("name");

 			//dodatak za polja
 			var field_index = name.indexOf("[");
 			if(field_index != -1)
 			{
 				var new_name = name.substring(10,field_index -1) + name.substring(field_index, name.length);
 			}            			            		
			else   
			{
				var new_name = name.substring(10,name.length -1);
			} 

   			//korekcija za backslash i jquery
			var backslash = String.fromCharCode(92);
			var backslash2 = String.fromCharCode(92) + String.fromCharCode(92);           			            		
 			if(new_name.indexOf(backslash) != -1)
 			{
 				new_name = new_name.split(backslash).join(backslash2);   
 			}   
 			             			            			
 			var datetimePolje = $(this).closest("div.form-group").parent().find("input[name$='" + new_name + "']");
 			
 			var old_val = datetimePolje.val();
 			var this_val = $(this).val();
 			if(old_val)
 			{
 				var new_val = old_val.substring(0,10) + " " + this_val;
 			}
 			else
 			{
 				var new_val = "__.__.____ " + this_val;
 			}             			
 			
 			//BRISANJE VRIJEDNOSTI
 			if(this_val == "")
 			{
 				var name_date = "_datepart_" + name.substring(10,name.length);
 				var datePolje = $(this).closest("div.form-group").parent().find("input[name$='" + name_date + "']");       
 				var new_date = datePolje.val(); 
 				
           		if(new_date == "") new_date = "__.__.____";              				
 				
 				var new_val = new_date + " __:__";     
 				
 				if(new_val == "__.__.____ __:__") datePolje.val("");   
 				
 				if(datetimePolje.prop("class").indexOf("konto-hide-date") != -1)
 				{
 					new_val = ""; //"__.__.____ __:__";             					            										
 				}  
 			}
 			             			
 			if(old_val != new_val)
 			{
 				//change event
 				datetimePolje.data("konto_old_value", old_val);
 				
 				var myFunc = datetimePolje.data("time_change_function");            			
 				if(myFunc == undefined) myFunc = datetimePolje.data("change_function");            				           			
 				if(myFunc != undefined)
 				{             			
 					var myParameters = datetimePolje.data("time_change_parameters");
 					if(myParameters == undefined) myParameters = datetimePolje.data("change_parameters");             			            			
 					if(myParameters == undefined)
 					{
 						KUtils.runFunction(myFunc, e);
 					}
 					else
 					{
 						KUtils.runFunction(myFunc, myParameters);	
 					}    
 				}               				
 				             				
  				$(this).data("blur", false); //napravi i blur	
  				$(this).data("mouseblur", true); //ne i mouse blur  
 				datetimePolje.val(new_val);
 				datetimePolje.trigger("change");            				
 			} 
 			
 			//blur event
			if(($(this).data("blur") == false))
			{             			
 				var myFunc = datetimePolje.data("time_blur_function");            			
 				if(myFunc == undefined) myFunc = datetimePolje.data("blur_function");            				           			
 				if(myFunc != undefined)
 				{             			
 					var myParameters = datetimePolje.data("time_blur_parameters");
 					if(myParameters == undefined) myParameters = datetimePolje.data("blur_parameters");             			            			
 					if(myParameters == undefined)
 					{
 						KUtils.runFunction(myFunc, e);
 					}
 					else
 					{
 						KUtils.runFunction(myFunc, myParameters);	
 					}    
 				}   							
											
				//Izvrši blur
				$(this).data("blur", true);	 
				$(this).data("mouseblur", true);            			
 				datetimePolje.trigger("blur");
 			}        
			if($(this).data("mouseblur") == false)
			{
				$(this).data("blur", true);	 
				$(this).data("mouseblur", true);							            			
 				datetimePolje.trigger("blur");							
			}       		
    	},
    	kontoTimeSSSeparateChange: function (e) {
 			$(this).trigger("blur");
    	},
     	kontoTimeSSSeparateKeyDown: function (root, e) {
    		var key = e.which || e.charCode || e.keyCode;

    		if(key == 9)
    		{
    			$(this).data("blur", false); //napravi i blur	
				$(this).data("mouseblur", true); //ne i mouse blur                  				
    		}                		
    		
			if((key == 13) && ($(this).data("hasKontoEnterNavigation"))){
      			var focusable = root.find("input,a,select,button,textarea")
        			.filter(":visible")
        			.filter(":not(:disabled)")
        			.filter(":not([readonly])")
					.filter(":not(.skipEnterTab)")
        			.filter(':not(.konto-readonly)');
    			var next = focusable.eq(focusable.index(this)+1);
    			if (next.length === 0) {
        			if (focusable.length === 0)
            			return false;
        			next = focusable.eq(0);
    			}    
    			$(this).data("blur", false); //napravi i blur	 
    			$(this).data("mouseblur", true); //ne i mouse blur             
    			next.focus().select();
			}      		
    	},
     	kontoTimeSSSeparateMouseDown: function () {
     		$(this).data("mouseblur", true);
     	},
     	kontoTimeSSSeparateMouseUp: function () {
     		$(this).data("mouseblur", false);
     	},
     	kontoTimeSSSeparateEach: function () {
 			$(this).removeClass("k-input");
 			         			
 			//dodaj kontrole evenata
			$(this).data("blur", false);	
			$(this).data("mouseblur", false);	     		
     	},
     	
       radioListGroupCreate: function(objPar){
           $obj = $(this); // treba zbog petlje (unutar nje je drugi "this")
           var i = 0;
           if (objPar.FItems.length){                
               $.each(objPar.FItems, function (key, val) {                              
                    dName = $obj.data('name');
                    $lab = $("<label>").addClass("list-group-item mb-0 py-0 px-2 border-0 bg-light");
                    $in = $("<input>").prop({type: "radio", name: dName, value: val.FName}).addClass('no-storage rb'+val.FName + ' ' + objPar.FName + 'Item').data("itemIndex", i++);
                    $s = $("<span>" + val.FDisplayText + "</span>");                           
                    $obj.append($lab.append($in).append($s));                    
                }); 
                //nakon kreiranja itema radi se za sam objekt 
                $('.list-group-item input:radio').siblings().each(function(){
                   if ($(this).text() == objPar.FValue){
                      $(this).siblings().prop('checked', true);
                   } 
                });
                
                //Visible
                if (objPar.FIsSetVisible){
                    $obj.setVisible(objPar.FVisible);       
                };
                
                if (objPar.FIsSetDisplayText){
                    $obj.before( $("<label>").text(objPar.FDisplayText) );
                }
            }
        },
        
        checkListGroupCreate: function(objPar){ 
            $obj = $(this); // treba zbog petlje (unutar nje je drugi "this") 
            
            //Visible
            if (objPar.FIsSetVisible){
                $obj.setVisible(objPar.FVisible);        
            };
            
            if (objPar.FItems.length){ 
                $.each(objPar.FItems, function (key, val) {             
                    if (val.FName != ""){
                        iClass = $obj.data('item-class');
                        if (!iClass) iClass=''; //da ne bude undefined
                        
                        //Visible
                        if (val.FIsSetVisible && !val.FVisible){
                            iClass += ' hide';        
                        };
                        
                        //Enabled
                        if (val.FIsSetEnabled && !val.FEnabled){
                            iClass += ' disabled';        
                        };
                        
                        $lab = $("<label>").addClass("list-group-item " + iClass);              
                        $in = $("<input>").prop({type: "checkbox", name: "fld-"+val.FName}).addClass('no-storage cb'+val.FName);
                                                
                        //Checked
                        if (val.FIsSetChecked){
                           $in.prop('checked', val.FChecked);    
                        }
                        
                        $s = $("<span>" + val.FDisplayText + "</span>");                           
                        $obj.append($lab.append($in).append($s));
                    }
                });
            }
        },
        checkListGroupStringCreate: function(objPar){ 
            $obj = $(this); // treba zbog petlje (unutar nje je drugi "this") 
            var values = [];
            
            if (objPar.FIsSetValue){
				values = objPar.FValue.split('\r\n');	
			}
			
			//dodavanje skrivenog inputa ($inp) koji se prenosi na DS i u kojemu je rezelutat. Nakon svakog klika prolazi se po listi i puni ovo polje
			var ormName = $obj.data('orm-name');
			$inp = $('<input type="hidden" name="' + ormName + '" class="konto-input no-storage"/>');
			$obj.after($inp);
			
			$.each(values, function (key, val) {
                iClass = $obj.data('item-class');
                if (!iClass) iClass=''; //da ne bude undefined                         
       
                //sad još tu razdvajanje val='db;text;opcije'
                var splitVal = val.split(';');
                var db_polje = splitVal[0];
                var display_text = splitVal[1];
                var opcije = '';
                var o_checked = 'C';
                
                //ovo mora biti prije opcija zbog postavljanja checked
                $in = $("<input>").prop({type: "checkbox"}).data('db', db_polje).addClass('no-storage'); 

                if (splitVal.length == 3){
					opcije = splitVal[2];
					//možda jos razrada opcija, ako imamo Checked, Hide, Disabled 
					if (opcije.indexOf(o_checked) != -1 ){
						$in.prop('checked', true);	
					}
				}

				//spajanje objekata na div
                $s = $("<span data-db=" + db_polje + " >" + display_text + "</span>");
                $lab = $("<label>").addClass("list-group-item " + iClass);                          
                $obj.append($lab.append($in).append($s))

				//za svaki klik prođemo kroz sve CB u listi i pokupimo one koji su checked
			    $lab.on("click", "input", function(e){
					var res = [];
					$(this).closest('div.list-group-string')
						.find('.list-group-item')
						.each(function(key, val){
							if ($(this).find('input').is(':checked')){
								var db = $(this).find('span').data('db');
								res.push(db);
							}
						});	
					var resJoin = res.join(",");
					var OrmName = $(this).closest('div.list-group-string').data('orm-name');
					var grupInp = $(this).closest('div.list-group-string').closest('div.form-group').find('[name="' + OrmName + '"]');
					grupInp.val(resJoin); 
				});               			
            });

        },    
        _setCBExtendedFPProperty: function(formParam){
            //Enabled
            if (formParam.FIsSetEnabled){
                $(this).setEnabled(formParam.FEnabled);       
            };
            //Checked
            if (formParam.FIsSetChecked){
               $(this).setKontoChecked(formParam.FChecked);    
            } 
            //DisplayText
            if (formParam.FIsSetDisplayText){
               $(this).find('label').text(formParam.FDisplayText);    
            }
        },
        _setCBNormalFPProperty: function(formParam){
            $lab = $(this).find('label');
            $in = $(this).find('input');
            $s = $(this).find('span');
            //Enabled - sumnjivo da li radi
            if (formParam.FIsSetEnabled && !formParam.FEnabled){
                $lab.prop('disable', true);       
            };
            //Checked
            if (formParam.FIsSetChecked){
               $in.prop('checked', formParam.FChecked);    
            } 
            //DisplayText
            if (formParam.FIsSetDisplayText){
               $s.text(formParam.FDisplayText);    
            } 
        },
        setCheckboxFPProperty: function(formParam){
            //Visible
            if (formParam.FIsSetVisible){
                $obj.setVisible(formParam.FVisible);        
            }; 
       
            if ( $(this).hasClass('konto-checkbox-extended') ){
                $(this)._setCBExtendedFPProperty(formParam);        
            }else{
                $(this)._setCBNormalFPProperty(formParam);    
            }
        },
        setKontoIspisInputFPProperty: function(formParam){
            var that = $(this);
            var rez = []; //polja koja su postaljena i koja ćemo maknuti iz cache
            //Value
            if (formParam.FIsSetValue){
                rez.push(that.data('name'));
                var kendoI = $(this).data("kendoIspis");                
                var val = formParam.FValue;
                if (val){
                    switch (that.data("kendoIspis").dataType) {
                        case "date": 
                                val = KUtils.Date(formParam.FValue);
                                break;
                        case "int":
                                val = KUtils.parseInt(formParam.FValue);
                                break;
                    }
                    var last2 = formParam.FName.substr(formParam.FName.length - 2);
	                var params = [val];
	                if (kendoI.dsMethodParam) {
						var value = val;
	                    var calculatedValue = eval("(" + kendoI.dsMethodParam + ")");
	                    if (!Array.isArray(calculatedValue))
	                        params = [calculatedValue];
	                    else
	                        params = calculatedValue;
	                }  
	                if (kendoI.dsMethod){			
		    			$.dsDirectCall({
		    				method: kendoI.dsMethod,
		    				params: params,
		    				done: function (data) {
		    					if (data) {
		    						var newData = $.dsObjectToJS(data);
				                    if (last2 == "Od"){
										kendoI.clear();
										kendoI._onOdabir(newData, "from"); 
				                    }else if(last2 == "Do"){
				                        kendoI._onOdabir(newData, "until");     
				                    }else{
										kendoI.clear();
										kendoI._onOdabir(newData, "add");
				                    }
		    					}
		    				},
		    				error: function (error) {
		    					//obrada greške?
		    				}
		    			});
	    			}else{ //za date
	                    if (last2 == "Od"){
							kendoI.clear();
							kendoI._onOdabir(val, "from"); 
	                    }else if(last2 == "Do"){
	                        kendoI._onOdabir(val, "until");     
	                    }else{
							kendoI.clear();
							kendoI._onOdabir(val, "add");
	                    }
					}
                }                     
            }
            return rez; 
        }	
    });    	
} (jQuery));